import styled from 'styled-components';

const Container = styled.div`
  display: flex;
  flex-wrap: wrap;
  height: 100%;
  justify-content: center;
  margin-left: auto;
`;

export default Container;
